<div class="main-menu" [ngClass]="{ 'open': isOpen }">
  
  <a class="toggle" title="Ouvrir/Fermer le menu" (click)="toggle()">
    <t-icon name="menu"></t-icon>
  </a>

  <a class="profile" title="Editer votre profile" (click)="close()" routerLink="/profile">
    <t-icon name="account_circle"></t-icon>
    <span class="fullname" *ngIf="!currentUser">
      Chargement...
    </span>
    <span class="fullname" *ngIf="currentUser">
      {{ currentUser.fullname }}
    </span>
  </a>

  <a class="menu-item" title="Dossiers" (click)="close()" routerLink="/dossiers" routerLinkActive="active">
    <t-icon name="folder"></t-icon>
    <span class="text">
      Dossiers
    </span>
  </a>

  <a class="menu-item" title="Enregistrements" (click)="close()" routerLink="/records" routerLinkActive="active">
    <t-icon name="folder_shared"></t-icon>
    <span class="text">
      Enregistrements
    </span>
  </a>

  <a class="menu-item" title="Opérations" (click)="close()" routerLink="/operations" routerLinkActive="active">
    <t-icon name="extension"></t-icon>
    <span class="text">
      Opérations
    </span>
  </a>

  <a class="menu-item" title="Registre des actions" (click)="close()" routerLink="/shares-ledger" routerLinkActive="active" *ngIf="isSLFeatureEnabled">
    <t-icon name="seal"></t-icon>
    <span class="text">
      Registre des actions
    </span>
  </a>

  <a class="menu-item" title="Registres" (click)="close()" routerLink="/documents-ledger" routerLinkActive="active" *ngIf="isDLFeatureEnabled">
    <t-icon name="folder_seal_check"></t-icon>
    <span class="text">
      Registres
    </span>
  </a>

  <a class="menu-item" title="Données INPI" (click)="close()" routerLink="/inpi" routerLinkActive="active">
    <t-icon name="inventory"></t-icon>
    <span class="text">
      Données INPI
    </span>
  </a>

  <a class="menu-item" title="Paramètres" (click)="close()" routerLink="/settings" routerLinkActive="active" *ngIf="currentUser && currentUser.is_admin">
    <t-icon name="settings"></t-icon>
    <span class="text">
      Paramètres
    </span>
  </a>

  <a class="menu-item" title="Déconnexion" (click)="logout()">
    <t-icon name="power_settings_new"></t-icon>
    <span class="text">
      Déconnexion
    </span>
  </a>

</div>